/**
 * CSP Nonce Setup for styled-components
 *
 * This file MUST be imported before any styled-components imports.
 * It sets the __webpack_nonce__ global variable which styled-components
 * uses to add nonce attributes to dynamically injected <style> tags.
 *
 * The nonce is injected by nginx via a meta tag in the HTML.
 */

const cspNonceMetaTag = document.querySelector('meta[name="csp-nonce"]');
if (cspNonceMetaTag) {
  const nonce = cspNonceMetaTag.getAttribute('content');
  if (nonce) {
    // Set webpack nonce for styled-components and other libraries
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).__webpack_nonce__ = nonce;
  }
}

export {};
